import { AdminTenantsResponse } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAdminTenants(searchParams: string) {
  const url = `/v2/orm/admin/tenants?${searchParams}`;
  const request = new Request(url);

  return useAuthenticatedRequest<AdminTenantsResponse>(request, {
    queryKey: ['admin-tenants', { searchParams }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return {
        items: respJson.payload,
        total: respJson.total,
      };
    },
  });
}

export default useAdminTenants;
